import { useAuth } from "@/hooks/useAuth";
import { usePassesForSale } from "@/hooks/usePassesForSale";
import { useRouter } from "expo-router";
import { useState } from "react";

export function usePurchaseFlexPark() {
  const { user } = useAuth();
  const router = useRouter();
  const { passesForSale, isFetching } = usePassesForSale();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [selectedRateProductID, setSelectedRateProductID] = useState<string | null>(null);

  const handlePurchase = (rateProductID: string) => {
    setSelectedRateProductID(rateProductID);
    const selectedPass = passesForSale?.find((pass) => pass.rateProductID === rateProductID);

    if (!user || selectedPass?.showNotRedeemableWarning) {
      setIsModalOpen(true);
    } else if (selectedPass?.passSpecifications?.requiresPassphrase) {
      setIsPasswordModalOpen(true);
    } else {
      processPurchase(rateProductID);
    }
  };

  const processPurchase = (rateProductID: string) => {
    const selectedPass = passesForSale?.find((pass) => pass.rateProductID === rateProductID);
    const rateName = selectedPass?.passName;
    try {
      router.push({
        params: { isPurchasingPass: "true", rateID: rateProductID, rateName },
        pathname: "/cart",
      });
    } catch (error) {
      console.error("Error processing purchase:", error);
    }
  };

  return {
    user,
    passes: passesForSale,
    isFetching,
    selectedRateProductID,
    handlePurchase,
    processPurchase,
    isModalOpen,
    setIsModalOpen,
    isPasswordModalOpen,
    setIsPasswordModalOpen,
  };
}
